import { Toolbar } from '@pogokid/mui'
import React, { FC } from 'react'
import styles from './TopToolbar.module.css'
import { Text } from '~m/designSystem'
import { useScreenTitle } from '~m/AppUi/context'

interface TopToolbarProps {
  heading?: string
}

export const TopToolbar: FC<
  React.PropsWithChildren<TopToolbarProps>
> = ({ heading, children }) => {
  const screenTitle = useScreenTitle()
  const title = screenTitle ?? heading
  return (
    <Toolbar
      className={styles.TopToolbar}
      disableGutters={false}
      data-testid="top-toolbar"
    >
      {heading && (
        <Text
          variant="page-title"
          className={styles.TopToolbar__heading}
          data-testid="top-toolbar__heading"
        >
          {title}
        </Text>
      )}
      {children}
    </Toolbar>
  )
}
